import apiClient from '@/config/axios'
import type {
  AddPosition,
  AdjustPosition,
  ApiResponse,
  AuditLogResponse,
  BacktestingPayload,
  BackTestResult,
  BasketResponse,
  BBDeploymentPayload,
  BbStrategyDetailsDto,
  BBStrategyResponse,
  BBStrategyResponseById,
  CachedStrategyItem,
  CombinedOrderResponse,
  FilteredScannerList,
  GroupResponse,
  HsTokenResponse,
  IHoldingsApiResponse,
  LogResponse,
  MFBasketResponse,
  MFOrderStatus,
  MFResponse,
  MmmScoreGrouped,
  MutualFundDetails,
  NseSectorResponse,
  PlanPrefSet,
  PnlResponse,
  PopularStrategyResponse,
  PortfolioResponse,
  Positions,
  PredefinedSystemBuilder,
  ScannerList,
  SellPositionsResponse,
  SimulatorPayload,
  SimulatorResponse,
  StrategyDetails,
  TradeBasketResponse,
  UpdateBbStrategyDto,
  WpPost
} from '@/store/momentumStore/types'
import type { AxiosResponse } from 'axios'

export function getStrategyData(): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/getInvestingStrategies')
}
export function fetchTradeStrategyData(): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/getTradeStrategies')
}
export function fetchMFStrategyData(): Promise<AxiosResponse<ApiResponse<MutualFundDetails[]>>> {
  return apiClient.post('/web/api/getMFStrategies')
}

export function postStrategyData(
  strategyDetails: StrategyDetails
): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/postmstrategy', { strategyDetails })
}
export function deployBBStrategy(
  strategyDetails: BBDeploymentPayload
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/createbbstrategy', strategyDetails)
}

export function updateBBStrategy(
  strategyDetails: UpdateBbStrategyDto
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/updatebbstrategy', strategyDetails)
}

export function postTradeStrategyData(
  strategyDetails: StrategyDetails
): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/posttradestrategy', { strategyDetails })
}

export function saveMFStrategyData(
  strategyDetails: MutualFundDetails
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/postMfStrategy', { strategyDetails })
}
export function postEditedMFStrategyData(
  strategyDetails: MutualFundDetails
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/editMfStrategy', { strategyDetails })
}
export function postEditedStrategyData(
  strategyDetails: StrategyDetails
): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/puteditmstrategy', { strategyDetails })
}
export function postTradeEditedStrategyData(
  strategyDetails: StrategyDetails
): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/editTradeStrategy', { strategyDetails })
}
export function statusEditMStrategy(
  id: string | undefined
): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/puteditstatusmstrategy', null, { params: { id } })
}

export function deleteStrategy(id: number): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/deletemstrategy', null, { params: { id } })
}
export function deleteBBStrategy(id: number): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/deletembbstrategy', null, { params: { id } })
}
export function deleteMFStrategy(id: number): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/deleteMfStrategy', null, { params: { id } })
}
export function deleteTradeStrategy(id: number): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/deleteMTradeStrategy', null, { params: { id } })
}
export function createStrategyCopy(
  id: number | undefined,
  name: string | undefined
): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/createStrategyCopy', { params: { id, name } })
}

export function fetchPredefinedGroups(): Promise<AxiosResponse<ApiResponse<string[]>>> {
  return apiClient.post('/web/api/nsegroups')
}
export function fetchMyGroups(): Promise<AxiosResponse<ApiResponse<string[]>>> {
  return apiClient.post('/web/api/nsemygroups')
}
export function fetchMySystemBuilder(): Promise<
  AxiosResponse<ApiResponse<PredefinedSystemBuilder[]>>
> {
  return apiClient.post('/web/api/getmysb')
}
export function fetchPublicSystemBuilder(): Promise<
  AxiosResponse<ApiResponse<PredefinedSystemBuilder[]>>
> {
  return apiClient.post('/web/api/getpublicsb')
}
export function fetchPredefinedSystemBuilder(): Promise<
  AxiosResponse<ApiResponse<PredefinedSystemBuilder[]>>
> {
  return apiClient.post('/web/api/getpresb')
}
export function fetchStrategyById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<StrategyDetails>>> {
  return apiClient.post('/web/api/getmstrategybyid', null, { params: { id } })
}
export function fetchMFStrategyById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<MutualFundDetails>>> {
  return apiClient.post('/web/api/getMfStrategyById', null, { params: { id } })
}
export function fetchTradeStrategyById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/getTradeStrategyById', null, { params: { id } })
}
export function fetchPopularStrategyDataid(
  id: string
): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/getmpopularstrategybyid', null, { params: { id } })
}
export function fetchTPopularStrategyById(
  id: string
): Promise<AxiosResponse<ApiResponse<StrategyDetails[]>>> {
  return apiClient.post('/web/api/getTPopularStrategyById', null, { params: { id } })
}
export function fetchMFPopularStrategyById(
  id: string
): Promise<AxiosResponse<ApiResponse<MutualFundDetails>>> {
  return apiClient.post('/web/api/getMFPopularStrategyById', null, { params: { id } })
}
export function fetchPositionById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<Positions[]>>> {
  return apiClient.post('/web/api/getInvestOpenPositionsById', null, { params: { id } })
}
export function fetchMFPositionById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<MFResponse>>> {
  return apiClient.post('/web/api/getMFOpenInvestmentsById', null, { params: { id } })
}
export function fetchClosedPositionById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<Positions[]>>> {
  return apiClient.post('/web/api/getClosedInvestPositionById', null, { params: { id } })
}
export function fetchTradePositionById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<Positions[]>>> {
  return apiClient.post('/web/api/getOpenTradePositionById', null, { params: { id } })
}
export function fetchTradeClosedPositionById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<Positions[]>>> {
  return apiClient.post('/web/api/getClosedTradePositionById', null, { params: { id } })
}

export function fetchBasketById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<BasketResponse>>> {
  return apiClient.post('/web/api/getInvestBasketById', null, { params: { id } })
}
export function executeBasketOrderById(
  id: number[]
): Promise<AxiosResponse<ApiResponse<CombinedOrderResponse>>> {
  return apiClient.post('/web/api/executeInvestBasketById', null, { params: { id: id.join(',') } })
}
export function forceRebalanceById(
  id: string | string[],
  isSipAmount: boolean
): Promise<AxiosResponse<ApiResponse<number>>> {
  const sipValue = isSipAmount ? 1 : 0
  return apiClient.post('/web/api/investForceRebalance', null, { params: { id, sipValue } })
}
export function cancelBasketOrderById(id: number[]): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/deleteInvestBasketById', null, { params: { id: id.join(',') } })
}
export function cancelTradeBasketOrderById(
  id: number[]
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/deleteTradeBasketById', null, { params: { id: id.join(',') } })
}

export function sellPosition(
  id: number
): Promise<AxiosResponse<ApiResponse<SellPositionsResponse>>> {
  return apiClient.post('/web/api/sellPosition', null, { params: { id } })
}
export function sellMFPosition(
  selectedScheme: string,
  selectedUnits: number
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/sellMFPosition', null, {
    params: { selectedScheme, selectedUnits }
  })
}
export function sellTradePosition(
  id: number
): Promise<AxiosResponse<ApiResponse<SellPositionsResponse>>> {
  return apiClient.post('/web/api/sellTradePosition', null, { params: { id } })
}

export function markAsSellPosition(
  adjustPosition: AdjustPosition,
  strategyId: string | string[]
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/markAsSell', { adjustPosition, strategyId })
}
export function markAsSellTradePosition(
  adjustPosition: AdjustPosition,
  strategyId: string | string[]
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/markAsSellTradePosition', { adjustPosition, strategyId })
}

export function addPositions(
  addPosition: AddPosition
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/addPositions', { addPosition })
}
export function addMultiplePositions(
  positions: Array<{ symbol: string; qty: number; price: number }>,
  strategyId: string | string[]
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/addMultiplePositions', {
    id: strategyId,
    positions: positions
  })
}
export function addTradePositions(
  addPosition: AddPosition
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/addTradePositions', { addPosition })
}
export function addMultipleTradePositions(
  positions: Array<{ symbol: string; qty: number; price: number }>,
  strategyId: string | string[]
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/addMultipleTradePositions', {
    id: strategyId,
    positions: positions
  })
}
export function getMargin(): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/getMargin')
}

export function logoutSession(): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/logout')
}

export function fetchRadarData(): Promise<AxiosResponse<ApiResponse<GroupResponse>>> {
  return apiClient.post('/web/api/getRadarGroups')
}

export function checkPortfolioStatus(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<PortfolioResponse>>> {
  return apiClient.post('/web/api/checkPortfolioStatus', null, { params: { id } })
}
export function checkTradePortfolioStatus(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<PortfolioResponse>>> {
  return apiClient.post('/web/api/checkTradePortfolioStatus', null, { params: { id } })
}

export function calculateRealizedAndUnRealizedPNL(
  id: number
): Promise<AxiosResponse<ApiResponse<PnlResponse>>> {
  return apiClient.post('/web/api/calculateRealizedAndUnRealizedPNL', null, { params: { id } })
}
export function calculateTradeRealizedAndUnRealizedPNL(
  id: number | undefined
): Promise<AxiosResponse<ApiResponse<PnlResponse>>> {
  return apiClient.post('/web/api/calculateTradeRealizedAndUnRealizedPNL', null, { params: { id } })
}
export function fetchStrategyNames(): Promise<AxiosResponse<ApiResponse<string[]>>> {
  return apiClient.post('/web/api/fetchStrategyNames', null, { params: {} })
}
export function fetchTradeStrategyNames(): Promise<AxiosResponse<ApiResponse<string[]>>> {
  return apiClient.post('/web/api/fetchTradeStrategyNames', null, { params: {} })
}
export function fetchMFStrategyNames(): Promise<AxiosResponse<ApiResponse<string[]>>> {
  return apiClient.get('/web/api/getMStrategyNames')
}
export function fetchFromConfigTable(): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/fetchFromConfigTable', null, { params: {} })
}
export function checkPlanPref(): Promise<AxiosResponse<ApiResponse<PlanPrefSet>>> {
  return apiClient.post('/web/api/checkPlanPref', null, { params: {} })
}
export function fetchPopularStrategyNames(): Promise<
  AxiosResponse<ApiResponse<PopularStrategyResponse[]>>
> {
  return apiClient.post('/getmpopularstrategy', null, { params: {} })
}
export function fetchPopularStrategiesByCategory(
  tag: string
): Promise<AxiosResponse<ApiResponse<PopularStrategyResponse[]>>> {
  return apiClient.post('/getmpopularstrategybycategory', null, { params: { tag } })
}
export function fetchTopPerformerStrategies(): Promise<
  AxiosResponse<ApiResponse<PopularStrategyResponse[]>>
> {
  return apiClient.post('/gettopperformerstrategies', null, { params: {} })
}
export function fetchAvailableTags(): Promise<AxiosResponse<ApiResponse<string[]>>> {
  return apiClient.post('/getavailabletags', null, { params: {} })
}
export function fetchMFPopularStrategyNames(): Promise<
  AxiosResponse<ApiResponse<PopularStrategyResponse[]>>
> {
  return apiClient.post('/web/api/getMFPopularStrategy', null, { params: {} })
}
export function fetchTradingPopularStrategyNames(): Promise<
  AxiosResponse<ApiResponse<PopularStrategyResponse[]>>
> {
  return apiClient.post('/web/api/getTPopularStrategy', null, { params: {} })
}

export function confirmAdjustHoldings(
  id: number,
  qty: number,
  price: number
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/confirmAdjustHoldings', null, { params: { id, qty, price } })
}
export function confirmAdjustClosedPositions(
  id: number,
  bqty: number,
  bprice: number,
  sqty: number,
  sprice: number
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/confirmAdjustClosedPositions', null, {
    params: { id, bqty, bprice, sqty, sprice }
  })
}
export function confirmAdjustTradeHoldings(
  id: number,
  qty: number,
  price: number
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/confirmAdjustTradeHoldings', null, { params: { id, qty, price } })
}
export function confirmAdjustTradeClosedPositions(
  id: number,
  bqty: number,
  bprice: number,
  sqty: number,
  sprice: number
): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/confirmAdjustTradeClosedPositions', null, {
    params: { id, bqty, bprice, sqty, sprice }
  })
}
export function fetchLogData(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<LogResponse[]>>> {
  return apiClient.post('/web/api/fetchLogData', null, { params: { id } })
}
export function fetchAuditLogData(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<AuditLogResponse[]>>> {
  return apiClient.post('/web/api/fetchAuditLogData', null, { params: { id } })
}
export function fetchHsToken(): Promise<AxiosResponse<ApiResponse<HsTokenResponse>>> {
  return apiClient.post('/web/api/fetchHstk', null, { params: {} })
}

export function fetchPoaStatus(): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/getPoaStatus', null, { params: {} })
}
export function fetchNseSector(): Promise<AxiosResponse<ApiResponse<NseSectorResponse>>> {
  return apiClient.post('/web/api/fetchNseSector', null, { params: {} })
}
export function fetchNseRate(
  symParam: string,
  givenDate: string | undefined
): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/fetchNseRate', null, { params: { symParam, givenDate } })
}
export function fetchTradeBasketById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<TradeBasketResponse>>> {
  return apiClient.post('/web/api/getTradeBasketById', null, { params: { id } })
}
export function fetchMFBasketById(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<MFBasketResponse>>> {
  return apiClient.post('/web/api/getMFBasketById', null, { params: { id } })
}
export function forceRebalanceTradeBasket(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/generateTradeBasket', null, { params: { id } })
}
export function forceRebalanceMFBasket(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/generateMFBasket', null, { params: { id } })
}
export function executeBasketTrades(
  id: number[],
  buzzarAlert: boolean
): Promise<AxiosResponse<ApiResponse<CombinedOrderResponse>>> {
  return apiClient.post('/web/api/executeTradeBasketById', null, {
    params: { id: id.join(','), buzzarAlert }
  })
}
export function executeMFBasketTrades(
  id: number[]
): Promise<AxiosResponse<ApiResponse<MFOrderStatus>>> {
  return apiClient.post('/web/api/executeMFBasketById', null, {
    params: { id: id.join(',') }
  })
}
export function calculateCurrentValue(
  id: string | string[]
): Promise<AxiosResponse<ApiResponse<number>>> {
  return apiClient.post('/web/api/calculateCurrentValue', null, { params: { id } })
}
export function fetchNSESymbolsCron(): Promise<AxiosResponse<ApiResponse<string[]>>> {
  return apiClient.post('/web/api/nsesymbols')
}
export function fetchSymbolsDataCronWithBe(
  name: string,
  type: string
): Promise<AxiosResponse<ApiResponse<string[]>>> {
  return apiClient.post('/web/api/nsesymbolswithbe', null, { params: { name, type } })
}
export function checkForValidRole(): Promise<AxiosResponse<ApiResponse<boolean>>> {
  return apiClient.post('/web/api/checkforvalidrole')
}
export function setPlanPref(prefIs: string): Promise<AxiosResponse<PlanPrefSet | undefined>> {
  return apiClient.post('/web/api/setPlanPref', null, { params: { pref: prefIs } })
}
export function getScannersList(): Promise<AxiosResponse<ApiResponse<ScannerList>>> {
  return apiClient.post('/web/api/getScannersList')
}
// export function getStrategyList(): Promise<AxiosResponse<FilteredScannerList[]>> {
//   return apiClient.post('/web/api/getStrategyList')
// }
export function fetchStrategyFromCode(
  code: string
): Promise<AxiosResponse<ApiResponse<FilteredScannerList[]>>> {
  return apiClient.post('/web/api/fetchStrategyFromCode', null, { params: { code } })
}
export function fetchStrategyNameFromCode(
  code: number
): Promise<AxiosResponse<ApiResponse<{ scannercode: string; strategyid: number }>>> {
  return apiClient.post('/web/api/fetchStrategyNameFromCode', null, { params: { code } })
}
export function getSimulatorResult(
  payload: SimulatorPayload
): Promise<AxiosResponse<ApiResponse<SimulatorResponse | null>>> {
  console.log('payload', payload)
  return apiClient.post('/web/api/getsimulatorresult', payload)
}
export function eSign(): Promise<AxiosResponse<ApiResponse<string>>> {
  return apiClient.post('/web/api/esign')
}
export function getBacktestingResult(
  payload: BacktestingPayload
): Promise<ApiResponse<BackTestResult[]>> {
  return apiClient.post('/web/api/getBacktestingresult', payload).then((res) => res.data)
}
export function fetchBlackboxStrategyDataById(
  id: number
): Promise<ApiResponse<BBStrategyResponseById>> {
  return apiClient.post(`/web/api/getbbstrategybyid?id=${id}`).then((res) => res.data)
}
export function validateBlackboxStrategyDataById(
  stratName: string,
  parentId: number
): Promise<ApiResponse<boolean>> {
  return apiClient
    .post(`/web/api/validatebbstrategy?stratName=${stratName}&parentId=${parentId}`)
    .then((res) => res.data)
}

export function fetchWPMomentumAll(): Promise<AxiosResponse<ApiResponse<WpPost[]>>> {
  return apiClient.post('/web/api/wp-momentum-all')
}
export function fetchWPStrategies(): Promise<AxiosResponse<ApiResponse<CachedStrategyItem[]>>> {
  return apiClient.post('/web/api/wp-strategies')
}
export const getHoldings = async (type: string): Promise<IHoldingsApiResponse> => {
  try {
    // console.log('🔄 Fetching holdings...')

    const response = await apiClient.post('/web/api/getHoldings', null, {
      params: {
        type: type
      }
    })

    // console.log('✅ Holdings fetched successfully:', response.data)
    // console.log('📊 Holdings count:', response.data?.data?.length || 0)

    return response.data
  } catch (error) {
    console.error('Error fetching holdings:', error)
    throw error
  }
}

export function fetchBBStrategies(): Promise<AxiosResponse<ApiResponse<BBStrategyResponse[]>>> {
  return apiClient.post('/web/api/getBBStrategies')
}

export function fetchAllBBStrategies(): Promise<
  AxiosResponse<ApiResponse<BbStrategyDetailsDto[]>>
> {
  return apiClient.post('/web/api/getallbbstrategies')
}

export function fetchMmmScore(): Promise<AxiosResponse<ApiResponse<MmmScoreGrouped>>> {
  return apiClient.post('/web/api/mmm-score-grouped')
}
